import { ErrorBoundary } from 'react-error-boundary';

import { PermissionType } from '@watershed/constants/permissions';
import { Teams } from '@watershed/constants/teams';
import { useOwner } from '@watershed/shared-frontend/hooks/useOwner';
import { maybeNotifySentry } from '@watershed/shared-frontend/utils/errorUtils';

import { ErrorFallback } from '../../components/ErrorFallback';
import ForbiddenPage from '../../components/ForbiddenPage';
import ApiKeyPage from '../../components/settings/api/ApiKeyPage';
import { Layouts } from '../../layouts/LayoutEnum';
import useHasPermission from '../../utils/useHasPermission';

function ApiSettingsPage() {
  useOwner(Teams.EnterpriseFoundations);
  const hasPermission = useHasPermission(PermissionType.Admin);
  if (!hasPermission) {
    return <ForbiddenPage missingPermission={PermissionType.Admin} />;
  }
  return (
    <ErrorBoundary
      FallbackComponent={ErrorFallback}
      onError={(error) => maybeNotifySentry(error)}
    >
      <ApiKeyPage />
    </ErrorBoundary>
  );
}

ApiSettingsPage.layout = Layouts.Settings;
export default ApiSettingsPage;
